import { SelectNameValue } from 'business/models/CustomModels';
import { EISelectBox } from 'components/customComponents/Layers/EICheckBox';
import React, { useEffect } from 'react';

const concUnits: SelectNameValue[] = [
  {
    value: 1,
    name: '%v/v',
  },
  {
    value: 2,
    name: '%w/v',
  },
  {
    value: 3,
    name: 'mM',
  },
  {
    value: 4,
    name: 'M',
  },
  {
    value: 5,
    name: 'pH',
  },
];

export const useSetMatchTableData = (doePreviewTableData, setDataRows, onCellChange) => {
  useEffect(() => {
    const matchDataTable: any[] = [];
    doePreviewTableData.forEach((row) => {
      let matchIngredientText = 'Match to ingredient';
      if (row.matchedIngredient) {
        matchIngredientText = '';
        matchIngredientText =
          matchIngredientText + row.matchedIngredient.selectedIngredient.name;
        matchIngredientText =
          matchIngredientText +
          ', ' +
          row.matchedIngredient.selectedStock.stockConcentration +
          ' ' +
          row.matchedIngredient.selectedStock.concentrationUnits +
          ' ' +
          row.matchedIngredient.selectedStock.vendorName;

        if (row.matchedIngredient.selectedStock.isBuffer) {
          matchIngredientText =
            matchIngredientText +
            ' pH ' +
            row.matchedIngredient.selectedStock.stockPh +
            (row.matchedIngredient.selectedHighpHStock ? 
            ' - ' +
            row.matchedIngredient.selectedHighpHStock?.stockConcentration  +
            ' ' +
            row.matchedIngredient.selectedHighpHStock?.concentrationUnits +
            ' ' +
            row.matchedIngredient.selectedHighpHStock?.vendorName : '');
        }
      }
      const rowObject = {
        name: row.name,
        matchTo: <div className="text-[blue]">{matchIngredientText}</div>,
        matchToIngredient: null,
        selectedUnit: row.selectedUnit,
        unit: (
          <EISelectBox
            placeholder="Unit"
            labelText=""
            selectedValue={row.selectedUnit.value}
            onChange={(e) => onCellChange(e, row.name)}
            options={concUnits}
            disabled={false}
          />
        ),
      };
      matchDataTable.push(rowObject);
    });
    setDataRows(matchDataTable);
  }, [doePreviewTableData]);
};
